function getNestedFieldNames(name, delimiter = "--") {
  function doJoin(arr) {
    const next = arr.slice(0, arr.length - 1);
    return [arr.join(delimiter), next.length > 0 ? doJoin(next) : []].flat();
  }
  return doJoin(name.split(delimiter));
}

export default getNestedFieldNames;
